import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, Modalidade } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class ModalidadeService extends BaseResourceService<Modalidade> {

  constructor(
    protected injector: Injector
  ) {
    super(`modalidades`, injector);
  }

}
